import React from "react";
// ANT DESIGN COMPONENTS
import { Dropdown, Space } from "antd";
import type { MenuProps } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
  updateBankAction,
  updateFormAction,
  updateOpenForm,
  updateOpenModalDeleteBankAction,
} from "../../../redux/banks/bankSlice";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// COMPONENTS
import TableActionsMenuItem from "../../components/table/TableActionsMenuItem";
// INTERFACES
import { BankActionsTableActionsInterface } from "../../../interfaces/Bank.interface";
import { FormAction } from "../../../types/enums";
import { RootState } from "../../../app/store";

function BankActionsTableActions({ selectedItem }: BankActionsTableActionsInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleOpenModalDelete = () => {
    dispatch(updateBankAction(selectedItem));
    dispatch(updateOpenModalDeleteBankAction(true));
  };

  // The table renders an inline editor keyed on `formAction === "edit"`, but
  // nothing put it into that state once this menu item was dropped, leaving
  // the editor unreachable and the screen effectively read-plus-delete only.
  const handleOpenModalEdit = () => {
    dispatch(updateBankAction(selectedItem));
    dispatch(updateOpenForm(true));
    dispatch(updateFormAction(FormAction.Edit));
  };
  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // ROW ACTIONS ************************************ */
  const manageActions = (): MenuProps["items"] => {
    const EDIT = hasPermission(Permission.PermissionNotDefined, permissionSet ?? [])
      ? {
          label: (
            <TableActionsMenuItem
              icon={faPenToSquare}
              text={t("general.edit")}
              onClick={handleOpenModalEdit}
            />
          ),
          key: "1",
        }
      : null;

    const DELETE = hasPermission(Permission.PermissionNotDefined, permissionSet ?? [])
      ? {
          label: (
            <TableActionsMenuItem
              icon={faTrash}
              text={t("general.delete")}
              onClick={handleOpenModalDelete}
            />
          ),
          key: "2",
        }
      : null;

    return [EDIT, DELETE];
  };
  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <Dropdown menu={{ items: manageActions() }} trigger={["click"]}>
        <Space className="generalStyles__hoverCursor">
          <FontAwesomeIcon icon={faEllipsis} />
        </Space>
      </Dropdown>
    </div>
  );
}

export default BankActionsTableActions;
